import { useEffect } from 'react';
import { triggerEvent } from '../../remote-education/remote-education-utils';

export const ScrollDeph: React.FC = () => {
  useEffect(() => {
    triggerEvent('scroll_depth');
  }, []);
  return <></>;
};
